import * as React from "react";

interface IProps {
    label: any
    name: string
    id: string
    className?: string
    value: boolean,
    disabled?: boolean,
    onChanged: (value: boolean) => void
}

export class Checkbox extends React.Component<IProps> {

    constructor(props: any) {
        super(props);
        this.handleOnChange = this.handleOnChange.bind(this);
    }

    public render() {

        const {
            label,
            name,
            id,
            value,
            disabled
        } = this.props;
        return (
            <div className={`falcon-checkbox form-group ${this.props.className || ""}`}>
                <div className="d-flex">
                    <div className="form-check mr-3">
                        <input className="custom-control-input true"
                               onChange={this.handleOnChange}
                               type="checkbox"
                               aria-labelledby={`${id}-label`}
                               name={name}
                               id={id}
                               checked={value}
                               disabled={disabled || false}
                        />
                        <label
                            id={`${id}-label`}
                            className="custom-control-label"
                            htmlFor={id}
                        >
                            <div className="checkbox-big"/>
                            <div className="checkbox-label">
                                <p>{label}</p>
                            </div>
                        </label>
                    </div>
                </div>
            </div>
        );
    }

    protected handleOnChange(event: any) {
        const checked = event.target.checked;
        this.props.onChanged(checked);
    }
}
